var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.728 30.728A18 18 0 115.272 5.273a18 18 0 0125.456 25.455zM25.846 12.34a1.543 1.543 0 000-2.186 1.543 1.543 0 00-2.186 0L18 15.814l-5.66-5.66a1.543 1.543 0 00-2.186 0 1.543 1.543 0 000 2.186l5.66 5.66-5.66 5.66a1.543 1.543 0 000 2.186c.605.605 1.58.605 2.186 0l5.66-5.66 5.66 5.66c.605.605 1.58.605 2.186 0a1.543 1.543 0 000-2.186L20.186 18l5.66-5.66z"
  })));
}
export default SvgCloseCircle;